export default __webpack_public_path__ + "static/media/twitter-logo.60c52053.svg";